<div>
    <div class="mb-3" [hidden]="newFirmwareVisible">
        <div class="mb-3">
            <button class="btn btn-sm btn-primary" (click)="displayNewFirmwareFormGroup()">
                <i class="fas fa-plus-circle"></i> New firmware
            </button>
        </div>
    </div>
    <div class="mb-3 background-hover" [hidden]="!newFirmwareVisible" [formGroup]="newFirmwareFormGroup">
        <div class="row">
            <div class="col">
                <div class="mb-3">
                    <label for="newFirmwareInternalModelInput">Internal Model</label>
                    <input type="text" class="form-control" id="newFirmwareInternalModelInput" placeholder="039A, 0290, 9A00, ..." formControlName="newFirmwareInternalModelInput">
                </div>
            </div>
            <div class="col">
                <div class="mb-3">
                    <label for="newFirmwareHardwareModelInput">Hardware Model</label>
                    <input type="text" class="form-control" id="newFirmwareHardwareModelInput" placeholder="000B, 000A, ..." formControlName="newFirmwareHardwareModelInput">
                </div>
            </div>
            <div class="col">
                <div class="mb-3">
                    <label>File</label>
                    <div>
                        <input type="file" class="form-control" id="newFirmwareFileInput" (change)="newFirmwareFileInputChange($event)" formControlName="newFirmwareFileInput">
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="mb-3">
                    <label for="newFirmwareVersionInput">Version (SUPPLIER)</label>
                    <input type="number" min="0" max="32767" class="form-control" id="newFirmwareVersionInput" formControlName="newFirmwareVersionInput" placeholder="5, 6, ...">
                </div>
            </div>
            <div class="col">
                <div class="mb-3">
                    <label for="newFirmwareVersionMkzInput">Version (MKZ)</label>
                    <input type="text" class="form-control" id="newFirmwareVersionMkzInput" formControlName="newFirmwareVersionMkzInput" placeholder="0.5, 0.6, ...">
                </div>
            </div>
            <div class="col">
                <div class="mb-3">
                    <label for="newFirmwareCrcInput">CRC</label>
                    <input type="text" class="form-control" id="newFirmwareCrcInput" placeholder="C28438D7, D8593A85, ..." formControlName="newFirmwareCrcInput">
                </div>
            </div>
        </div>
        <div class="mb-3 row gx-1">
            <div class="col-auto">
                <button class="btn btn-sm btn-primary" [disabled]="newFirmwareFormGroup.invalid" (click)="uploadNewFirmware()">
                    <i class="fas fa-cloud-upload-alt"></i> Upload
                </button>
            </div>
            <div class="col-auto">
                <button class="btn btn-sm btn-secondary" (click)="hideNewFirmwareFormGroup()">
                    <i class="fas fa-ban"></i> Cancel
                </button>
            </div>
        </div>
    </div>
</div>
<div *ngIf="firmwares && firmwares.length > 0">
    <h4>Configure firmwares</h4>
    <div class="mb-3 background-hover" *ngIf="selectedFirmwareToEdit" [formGroup]="editFirmwareFormGroup">
        <div class="row">
            <div class="col">
                <div class="mb-3">
                    <label for="editFirmwareInternalModelInput">Internal Model</label>
                    <input type="text" class="form-control" id="editFirmwareInternalModelInput" placeholder="039A, 0290, 9A00, ..." formControlName="editFirmwareInternalModelInput">
                </div>
            </div>
            <div class="col">
                <div class="mb-3">
                    <label for="editFirmwareHardwareModelInput">Hardware Model</label>
                    <input type="text" class="form-control" id="editFirmwareHardwareModelInput" placeholder="000B, 000A, ..." formControlName="editFirmwareHardwareModelInput">
                </div>
            </div>
            <div class="col">
                <div class="mb-3">
                    <label for="editFirmwareFileInput">File</label>
                    <input type="text" class="form-control" id="editFirmwareFileInput" formControlName="editFirmwareFileInput">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="mb-3">
                    <label for="editFirmwareVersionInput">Version (SUPPLIER)</label>
                    <input type="number" min="0" max="32767" class="form-control" id="editFirmwareVersionInput" formControlName="editFirmwareVersionInput" placeholder="5, 6, ...">
                </div>
            </div>
            <div class="col">
                <div class="mb-3">
                    <label for="editFirmwareVersionMkzInput">Version (MKZ)</label>
                    <input type="text" class="form-control" id="editFirmwareVersionMkzInput" formControlName="editFirmwareVersionMkzInput" placeholder="0.5, 0.6, ...">
                </div>
            </div>
            <div class="col">
                <div class="mb-3">
                    <label for="editFirmwareCrcInput">CRC</label>
                    <input type="text" class="form-control" id="editFirmwareCrcInput" placeholder="C28438D7, D8593A85, ..." formControlName="editFirmwareCrcInput">
                </div>
            </div>
        </div>
        <div class="mb-3 row gx-1">
            <div class="col-auto">
                <button class="btn btn-sm btn-primary" [disabled]="editFirmwareFormGroup?.invalid" (click)="updateSelectedFirmwareToEdit()">
                    <i class="fas fa-save"></i> Save
                </button>
            </div>
            <div class="col-auto">
                <button class="btn btn-sm btn-secondary" (click)="cancelSelectedFirmwareToEdit()">
                    <i class="fas fa-ban"></i> Cancel
                </button>
            </div>
        </div>
    </div>
    <div *ngIf="!selectedFirmwareToEdit">
        <table class="table table-sm table-striped table-hover">
            <thead>
                <tr>
                    <th scope="col">Internal Model</th>
                    <th scope="col">Hardware Model</th>
                    <th scope="col" colspan="3">Version (SUPPLIER &#8660; MKZ)</th>
                    <th scope="col">CRC</th>
                    <th scope="col">File</th>
                    <th scope="col">Date</th>
                    <th scope="col">Status</th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let firmware of firmwares">
                    <td scope="row">
                        {{ firmware.internalModel }}
                    </td>
                    <td>
                        {{ firmware.hardwareModel }}
                    </td>
                    <td style="text-align: right;">
                        {{ firmware.version }}
                    </td>
                    <td style="text-align: center;">
                        &#8660;
                    </td>
                    <td style="text-align: left;">
                        {{ firmware.mkzVersion }}
                    </td>
                    <td>
                        {{ firmware.crc }}
                    </td>
                    <td>
                        <a [href]="firmware.url" [title]="firmware.filename">
                            <i class="fas fa-download"></i>
                        </a>
                    </td>
                    <td>
                        <span class="text-muted">{{ (firmware.status == 'PUBLISHED' ? firmware.publishedTime : firmware.uploadedTime) | date: 'yyyy-MM-dd' : 'UTC' }}</span>
                    </td>
                    <td>
                        <span class="badge" [class.bg-secondary]="firmware.status == 'UPLOADED'" [class.bg-warning]="firmware.status == 'TO_VALIDATE'" [class.bg-info]="firmware.status == 'VALIDATED'" [class.bg-success]="firmware.status == 'PUBLISHED'">
                            <small class="">
                                <strong>{{ firmware.status }}</strong>
                            </small>
                        </span>
                    </td>
                    <td>
                        <a href="javascript:void(0)" class="text-warning" *ngIf="firmware.status == 'UPLOADED'" (click)="toValidateFirmware(firmware.id)">
                            <i class="fas fa-check"></i> To Validate
                        </a>
                        <a href="javascript:void(0)" class="text-info" *ngIf="firmware.status == 'TO_VALIDATE'" (click)="validateFirmware(firmware.id)">
                            <i class="fas fa-check"></i> Validate
                        </a>
                        <a href="javascript:void(0)" class="text-success" *ngIf="firmware.status == 'VALIDATED'" (click)="publishFirmware(firmware.id)">
                            <i class="fas fa-share"></i> Publish
                        </a>
                    </td>
                    <td>
                        <a href="javascript:void(0)" class="text-primary" *ngIf="(firmware.status == 'UPLOADED' || firmware.status == 'TO_VALIDATE')" (click)="displaySelectedFirmwareToEdit(firmware.id)">
                            <i class="fas fa-edit"></i> Edit
                        </a>
                    </td>
                    <td>
                        <a href="javascript:void(0)" class="text-danger" (click)="displayDeleteFirmware(firmware.id)" *ngIf="!deleteFirmwareVisibles[firmware.id]">
                            <i class="fas fa-trash-alt"></i> Delete
                        </a>
                        <a href="javascript:void(0)" class="text-danger" (click)="deleteFirmware(firmware.id)" *ngIf="deleteFirmwareVisibles[firmware.id]">
                            <i class="fas fa-exclamation-circle"></i> Confirm
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>